import { AppModule } from '../../lib/app-module';
import * as $ from 'jquery';
import { formToJson } from '../../lib/forms';
import { validateEmail, validateRequired } from '../../lib/validation';
import type { App } from '../..';
import { UserModuleExport } from '../user/user';

declare const window: Window & {app: App};

export interface ContactConfig {
    nameRequired?: boolean;
    messageRequired?: boolean;
}

export class ContactForm extends AppModule<ContactConfig> {
    private requiredFields: Required<ContactConfig>;
    private form: JQuery<HTMLFormElement>;
    private emailInput: JQuery<HTMLInputElement>;
    private nameInput: JQuery<HTMLInputElement>;
    private messageInput: JQuery<HTMLInputElement>;
    private successMessage: JQuery<HTMLElement>;
    private errorMessage: JQuery<HTMLElement>;
    private closeSuccess: JQuery<HTMLButtonElement>;
    private closeError: JQuery<HTMLButtonElement>;

    protected init(): void {
        const requiredDefaults: Required<ContactConfig> = {nameRequired: true, messageRequired: true};
        this.requiredFields = {...requiredDefaults, ...this.config};
        this.form = $('#contact-form');
        this.emailInput = $('#contact-email');
        this.nameInput = $('#contact-name');
        this.messageInput = $('#contact-message');
        this.successMessage = $('#form-success');
        this.errorMessage = $('#form-error');
        this.closeSuccess = $('#close-form-success');
        this.closeError = $('#close-form-error');
        this.monitorEvents();
        this.attemptPrefill();
    }

    private attemptPrefill(): void {
        if (window.app.m.user) {
            const userMod = window.app.m.user as UserModuleExport;
            userMod.fillEmail(this.emailInput[0]);
            userMod.fillName(this.nameInput[0]);
        }
    }

    private monitorEvents(): void {
        this.emailInput.on('focusout',  () => this.performEmailValidation(this.emailInput.val()));
        this.nameInput.on('focusout',  () => this.performNameValidation(this.nameInput.val()));
        this.messageInput.on('focusout',  () => this.performMessageValidation(this.messageInput.val()));
        this.closeError.on('click', () => this.errorMessage.hide());
        this.closeSuccess.on('click', () => this.successMessage.hide());
        this.form.on('submit', (event) => this.submitForm(event));
    }

    private async submitForm(event: JQuery.SubmitEvent): Promise<void> {
        event.preventDefault();
        const data = formToJson(this.form);
        if (!this.validateData(data)){
            return;
        }
        return new Promise((resolve) => {
            $.ajax({
                type: 'POST',
                url: 'https://api.desajustecreativo.com/contact',
                data: JSON.stringify(data),
                contentType: 'application/json',
                success: (() => {
                    this.submitSuccess();
                    resolve();
                }),
                error: (error => {
                    this.submitError(error);
                    resolve();
                })
            });
        });
    }

    private validateData(data: {[key: string]: string}): boolean {
        const emailValid = this.performEmailValidation(data.email);
        const nameValid = this.performNameValidation(data.name);
        const messageValid = this.performMessageValidation(data.message);
        return emailValid && nameValid && messageValid;
    }

    private performEmailValidation(value: unknown): boolean {
        return this.fieldValidation(
            'field-email',
            () => validateEmail(value)
        );
    }

    private performNameValidation(value: unknown): boolean {
        return this.fieldValidation(
            'field-name',
            () => !this.requiredFields.nameRequired || validateRequired(value)
        );
    }

    private performMessageValidation(value: unknown): boolean {
        return this.fieldValidation(
            'field-message',
            () => !this.requiredFields.messageRequired || validateRequired(value)
        );
    }

    private fieldValidation(divToToggleError: string, validateFunc: () => boolean): boolean {
        const fieldDiv = document.getElementById(divToToggleError) as HTMLElement;
        if (!validateFunc()) {
            fieldDiv.classList.add('error');
            return false;
        }
        fieldDiv.classList.remove('error');
        return true;
    }

    private submitSuccess(): void {
        this.successMessage.show();
        this.errorMessage.hide();
        this.form.trigger('reset');

    }
    
    private submitError(error: unknown):  void {
        console.log('error',  error);
        this.successMessage.hide();
        this.errorMessage.show();
    }
}